module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail/modal-mail-sender/modal-mail-sender.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail/modal-mail-sender/modal-mail-sender.component.sass
// module chunks = main